const React = require("react");

const getNrWorkingDaysBetweenDates = require("./Helpers").getNrWorkingDaysBetweenDates;
const CAMPAIGN_DURATION = 30; //days
const CLICK_PROMISE_FACTOR = 0.5;
const moment = require("moment");

function renderFirestoreBtn(campaignId) {
  return (
    <span className="cta--margin-right">
      <a
        className="cta cta--inline"
        style={{ backgroundColor: "#ffca28", color: "black" }}
        href={`https://console.firebase.google.com/u/0/project/talentbait-app-production/database/firestore/data/~2Fcampaigns~2F${campaignId}`}
        target="_blank"
        rel="noreferrer"
        // eslint-disable-next-line i18next/no-literal-string
      >
        Firestore öffnen
      </a>
    </span>
  );
}

function renderFirestoreApplicantsBtn(campaignId) {
  return (
    <span className="cta--margin-right">
      <a
        className="cta cta--inline"
        style={{ backgroundColor: "#ffca28", color: "black" }}
        href={`https://console.firebase.google.com/u/0/project/talentbait-app-production/database/firestore/data/~2Fats~2F${campaignId}`}
        target="_blank"
        rel="noreferrer"
        // eslint-disable-next-line i18next/no-literal-string
      >
        Bewerber-DB öffnen
      </a>
    </span>
  );
}

function renderPerformance(lifeTimeBudget, totalClicks, creationDateString, status) {
  if (status === "IN_PROGRESS" || status === "SCHEDULED" || status === "PAUSED") {
    return <span>-</span>;
  }

  const clicks = parseInt(totalClicks || 0, 10);
  const budget = parseInt(lifeTimeBudget, 10);

  // Calculate some dates
  const startDate = new Date(creationDateString);
  const endDate = new Date();
  endDate.setDate(startDate.getDate() + CAMPAIGN_DURATION);
  const today = new Date();

  // Duration without Saturday & Sunday
  const remainingDays = parseInt(getNrWorkingDaysBetweenDates(today, endDate), 10);
  // Duration without Sunday & Monday
  const daysRunning = parseInt(getNrWorkingDaysBetweenDates(startDate, today), 10);

  const clicksNeeded = parseInt(budget * CLICK_PROMISE_FACTOR, 10);

  const avgClicksCurrent = (clicks / daysRunning).toFixed(2);
  const avgClicksNeeded = ((clicksNeeded - clicks) / remainingDays).toFixed(2);

  status = "ERROR";
  if (parseInt(avgClicksNeeded, 10) <= 0) {
    status = "FULLFILLED";
  } else if (parseInt(avgClicksCurrent, 10) >= parseInt(avgClicksNeeded, 10)) {
    status = "ACTIVE";
  }

  if (totalClicks > clicksNeeded) {
    status = "ACTIVE";
  }

  const label = `${avgClicksCurrent} / ${avgClicksNeeded} / ${clicksNeeded}`;

  return (
    <span
      data-tip={"AV Clicks \n AVG Clicks Needed / Clicks Needed"}
      className={`dashboard__badge dashboard__badge--${status}`}
    >
      {label}
    </span>
  );
}

function sumValueFromDictKey(dict, keyName) {
  var total = 0;
  for (const key in dict) {
    // eslint-disable-next-line no-prototype-builtins
    if (dict.hasOwnProperty(key)) {
      const value = dict[key][keyName];
      total += parseInt(value, 10) || 0;
    }
  }
  return total;
}

const RELA = 0.5;

function getPercentageOfCampaignSpent(budget, metrics) {
  const total = budget * RELA;
  const spent = sumValueFromDictKey(metrics, "totalSpent");
  const perct = ((spent * 100) / total).toFixed(0);

  return perct;
}

function renderSpentBarChart(budget, metrics) {
  const perct = getPercentageOfCampaignSpent(budget, metrics);
  const spent = sumValueFromDictKey(metrics, "totalSpent");

  return (
    <div>
      <div className="progress-bar-tb" title={perct + "% / " + spent + "€ / " + budget + "€"}>
        <div className="progress-bar-tb__val" style={{ width: perct + "%" }}></div>
      </div>
      <span className="">{perct}%</span>
    </div>
  );
}

/**
 * Render line breaks in a text
 *
 * @param {string} text - Text to render
 * @param {string} [key] - Optional key, since we are mapping over an array
 * @returns An array of text elements with line breaks
 */
function renderLineBreaks(text, key) {
  const baseKey = key ? key : text;

  return text.split("\n").map(function (item, index) {
    const elementKey = `${baseKey}_${index}`;
    return (
      <span key={elementKey}>
        {item} <br />
      </span>
    );
  });
}

function durationInDays(actualDate, endDate) {
  var formatedActuaDate = moment(actualDate.toString(), "x").format("YYYY-MM-DD");

  var end = moment(endDate);
  var actual = moment(formatedActuaDate);

  const remainingDays = end.diff(actual, "days");

  return remainingDays;
}

module.exports = {
  renderPerformance,
  renderFirestoreBtn,
  renderFirestoreApplicantsBtn,
  renderSpentBarChart,
  getPercentageOfCampaignSpent,
  renderLineBreaks,
  durationInDays
};
